import { VehicleHistoryEvent } from './vehicle-history-event';

import moment from 'moment';

export class DoorHistory extends VehicleHistoryEvent {
    public type = 'DoorHistory';
    public doorId: number;
    public doorEventType: string;

    public override get description() {
        return moment(this.ts).format('HH:mm:ss');
    }

    public override get title() {
        return this.doorEventType;
    }

    public get isOpen() {
        return this.doorEventType === 'Open'; // Close
    }

    constructor(obj = null) {
        super();

        if (obj) {
            Object.assign(this, obj);
        }
    }
}
